import React from "react";
import { useMatches } from "react-router-dom";

import { faGift } from "@fortawesome/pro-solid-svg-icons";

import { ButtonIcon, Tooltip } from "@performyard/py-components";

// hooks
import { useRbacPrimaryRolePermissions } from "../../api/hooks";
import { useFeatureFlagQuery } from "../../hooks/useFeatureFlag";

// utils
import { isInIframe } from "../../utils/isInIframe";

// styles
import "./CelloLauncher.scss";

const ALLOWED_CELLO_ROUTES = [
	"/",
	"/user/",
	"/feedback/",
	"/reviews/",
	"/employees/goals",
	"/employees/",
	"/review/",
	"/company/reviews",
	"/company/goals",
	"/company/feedback",
	"/company/meetings",
	"/reporting/",
	"/analytics/",
];

const CelloLauncher = () => {
	const { value: celloFeatureVisible } = useFeatureFlagQuery("ff-is-in-app-referrals-enabled", false);
	const {
		data: celloPermissions,
		isLoading: isRbacLoading,
		error: rbacError,
	} = useRbacPrimaryRolePermissions("cello");

	const matches = useMatches();
	const currentPath = matches.length > 0 ? matches[matches.length - 1]?.pathname : "";

	const shouldShowCello = ALLOWED_CELLO_ROUTES.some((route) => {
		if (route === "/") {
			return currentPath === "/";
		}
		return currentPath?.startsWith(route);
	});

	// we don't want to show the cello launcher in an iframe
	if (isInIframe()) {
		return null;
	}

	// Check if feature flag is enabled
	if (!celloFeatureVisible) {
		return null;
	}

	// Show loading state while RBAC permissions are being fetched
	if (isRbacLoading) {
		return null;
	}

	// If there's an error fetching permissions, don't show the component
	if (rbacError) {
		console.warn("Failed to fetch Cello RBAC permissions:", rbacError);
		return null;
	}

	// Check if user has permission to access Cello
	if (!celloPermissions?.includes("cello:getCelloToken")) {
		console.log("User does not have permission to access Cello");
		return null;
	}

	// Cello hooks onto the id name 'cello-custom-launcher'to show our custom launcher
	return (
		<section className="fixed bottom-[24px] left-0 z-[100] pl-2">
			{shouldShowCello && (
				<div className="hide-in-pdf scale-[1.71] transition-all duration-300">
					<div id="cello-custom-launcher" style={{ position: "relative" }} data-cello="true">
						<Tooltip
							offset={-4}
							placement="right"
							content="Refer Friends & Earn Rewards"
							dangerouslySetClassName="z-[150]"
							asChild
						>
							<ButtonIcon
								data-testid="cello-referral-button"
								variant="ghost"
								color="primary"
								shade={7}
								size={32}
								onClick={() => {}}
								dangerouslySetClassName="bg-primary-1 text-primary-5 shadow-[0_4px_4px_0_rgba(0,0,0,0.25)] rounded-l-none hover:bg-primary-2 hover:text-primary-7 active:bg-primary-3 active:text-primary-7"
								icon={faGift}
								aria-label="Refer Friends & Earn Rewards"
							/>
						</Tooltip>
					</div>
				</div>
			)}
		</section>
	);
};

export default CelloLauncher;
